export default "__VITE_ASSET__UqNFCwA8__";